<template>
  <div class="l_reset_stamp_faq">
    <div class="container">
      <div class="content">
        <h3>スタンプカードの有効期限</h3>
        <hr />
        <p>
          スタンプカード及びランクの有効期限は初めてスタンプをゲットしてから1年となります。<br />
          スタンプカードの有効期限は、スタンプカードの右上に記載してあります。<br />
          有効期限を過ぎると、スタンプの個数・カードランクにかかわらず、スタンプカードは<span
            class="strong"
            >０スタンプにリセット</span
          >されます。
        </p>
        <img :src="require('@/assets/img/faq/yuukoukigenn20221114.png')" />
      </div>
      <div class="content">
        <h3>リセット後のランクについて</h3>
        <hr />
        <p>
          リセットされるとカードランクは<span class="strong"
            >ブロンズに戻ります。</span
          >過去のスタンプ履歴はこちら から閲覧することができます。
        </p>
        <div class="l_button__external">
          <UIButton :label="'スタンプ獲得履歴'" @click="tapStampHistory" />
        </div>
      </div>
      <div class="content">
        <h3>リセット前にためた特典とスタンプについて</h3>
        <hr />
        <p>
          未使用のクーポン/フリーパス及び何度でも使用可能なクーポンで有効期限に達していないクーポン/フリーパスはスタンプカード及びランクリセット後もそのまま引き継がれ有効期限まで使用が可能です。
        </p>
        <br />
        <p>
          ※クーポンの内容に関しては予告なく変更になる場合がございますのでご了承願います。
        </p>
        <br />
        <p><span class="strong">■スタンプ</span></p>
        <p>
          リセット前にためたスタンプのうち、特典化
          されていない端数分はリセット後のカードに
          引き継がれます。（最大9スタンプ） 例）
          ゴールドカードで78スタンプ獲得時にリセ ットがかかった場合。
        </p>
        <br />
        <p>
          <span class="strong">＜70スタンプ分＞</span><br />
          ⇨特典化されているので、リセットされます。
        </p>
        <br />
        <p>
          <span class="strong">＜8スタンプ分＞</span><br />
          ⇨特典化されていない<span class="strong">端数分</span>は、そのまま
          <span class="strong">新しいカードに引き継がれます</span>。
        </p>
      </div>

      <div class="content">
        <h3>累計獲得スタンプ数の確認</h3>
        <hr />
        <p>
          これまでに獲得した全てのスタンプ数がご確認いただけます。（スタンプカードリセット以前のスタンプ数も含みます。）<br />
          リセット時に引き継がれたスタンプ数は重複してカウントされません。（実際に獲得した月分のみカウント）<br />
        </p>
        <div class="l_button__external">
          <UIButton :label="'スタンプ獲得履歴'" @click="tapStampHistory" />
        </div>
        <br />
        <p>
          スタンプページの「スタンプ獲得履歴」のボタンからもご確認いただけます。
        </p>
        <img :src="require('@/assets/img/faq/2308-stmp1.png')" alt="" />
        <br />
      </div>

      <div class="content">
        <h3>リセットされたスタンプ獲得履歴</h3>
        <hr />
        <p>
          スタンプカードリセット前のスタンプ履歴がご確認いただけます。<br />
          スタンプページの「スタンプ獲得履歴」のボタンをタップし、「これまでの年間ランク」の欄をご確認ください。<br />（スタンプカードリセットがかかっていない方には表示されません。）
        </p>
        <img
          :src="require('@/assets/img/faq/btn_watchstamphistory.png')"
        /><br />
        「スタンプを見る」をタップ<br />
        <img :src="require('@/assets/img/faq/cardsample.png')" /><br />

        <p>
          これまでの獲得スタンプが、年度ごとにまとめてご確認いただけます（上部に表示されているランクは、該当する1年で最終的に達したランクになります。）
        </p>
        <div class="l_button__external">
          <UIButton :label="'スタンプ獲得履歴'" @click="tapStampHistory" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
export default {
  name: 'FAQResetStamp',
  components: {
    UIButton
  },
  created() {
    document.title = 'スタンプカードリセット'
  },
  methods: {
    ...mapActions('Native', ['actionNavigateTo']),
    ...mapActions('Analytics', ['trackEvent']),
    goBack: function () {
      this.$router.push({ name: 'FAQ' })
    },
    tapLink() {
      this.trackEvent(FactoryTrack.createSettingApp())
      this.actionNavigateTo('1') // 1:許諾画面
    },
    tapFAQPremium() {
      this.trackEvent(FactoryTrack.createFAQPremium())
      this.$router.push({ name: 'FAQPremium' })
    },
    tapStampHistory() {
      this.trackEvent(FactoryTrack.createStampHistory())
      this.actionNavigateTo('7') // 1:許諾画面
    }
  }
}
</script>

<style lang="scss" scoped>
.l_reset_stamp_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
}

.l_reset_stamp_faq h3,
.l_reset_stamp_faq h4 {
  color: var(--accent-color);
}

.l_reset_stamp_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}
.l_reset_stamp_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
  p {
    text-align: justify;
  }
  .strong {
    font-weight: bold;
  }
}
.l_reset_stamp_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid var(--accent-color);
}
.l_reset_stamp_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.caption {
  text-align: left;
  width: 100%;

  &.right {
    text-align: right;
  }

  font-size: 3vw;
  color: rgb(102, 102, 102);
}
</style>
